import gsap from 'gsap'
import { Power2 } from 'gsap'
import koko from '../koko-framework/koko'
import { v, au } from '../koko-framework/shorthand'
import app from '../koko-framework/app'
import { CaesarCipherController } from '../controller/CaesarCipherController'
import { SHIFT_ROTATE_INCREMENTS } from '../model/CaesarCipherModel'
import { Input } from '../koko-framework/ui/input'
import { GameTimeController } from '../controller/GameTimeController'
import { CAESAR } from '../model/GameModel'
import gameState from '../model/GameModel'
import * as PIXI from 'pixi.js'
import { SimpleCustomKeyboard } from '../koko-framework/ui/SimpleCustomKeyboard'
import { keyboardSetup } from '../model/CustomKeyboard'
import { setupClicker } from '../controller/ButtonController'

const NO_KEYBOARD = 0;
const ANSWER_KEYBOARD = 1;
const SHIFT_KEYBOARD = 2;

export class CaesarCipherView extends koko.view {
    controller = null;
    timeController = null;
    clicksAllowed = false;
    answerInput = null;
    canSubmitAnswer = false;
    popOpen = false;

    customKeyboard = null;
    keyboardView = null;
    keyboardOpen = false;
    currentKeyboard = NO_KEYBOARD;

    viewActive = false;

    hintAllowed = false;

    /* constructor (){
        super();
    } */

    assets = [
        { id: 'codebreaker_assets', src: 'img/codebreaker-0.json' },
        { id: 'codebreaker_assets_1', src: 'img/codebreaker-1.json' },
        { id: 'codebreaker_assets_2', src: 'img/codebreaker-2.json' },
        { id: 'bebas_font_small', src: 'img/fonts/bebas_small.fnt'},
        { id: 'type_font_small', src: 'img/fonts/typerighter_small.fnt'},
    ]

    buildView (){
        var vp = app.viewPort;
        // console.log('vp: ', vp);

        this.children = koko.display.buildLayout([
            {name:'gameContainer', type:'container'},

            { type: 'sprite', parent: 'gameContainer', id: 'BG_pattern', name: 'bg', x: -280, y: 0, width: 1326, height: 1355},

            { type: 'sprite', parent: 'gameContainer', id: 'Casesar_title', name: 'title', x: 148, y: 286, width: 468, height: 63},

            { type: 'bmptext', parent: 'gameContainer', text: 'Use the caesar cipher to decipher the\nfollowing message.', font: 'typrighter_small', size: 30, tint: 0, name: 'instructions', align:'center', x: vp.centerX, y: 358},

            { type: 'sprite', parent: 'gameContainer', id: 'message_carrier', name: 'message_carrier', x: 96, y: 423, width: 572, height: 132},
            { type: 'bmptext', parent: 'gameContainer', text: 'PHRASE', font: 'Bebas_small', size: 36, tint: 0xAE0313, name: 'scrambledText', x: vp.centerX, y: 470},

            { type: 'shape', parent: 'gameContainer', name: 'closeKeyboardOutside', x: 0, y: 900, width: 765, height: 600, fill: 0, alpha: 0},

            { type: 'bmptext', parent: 'gameContainer', text: 'Decoded message:', font: 'typrighter_small', size: 30, tint: 0, name: 'decodedTitle', align:'center', x: vp.centerX, y: 946},
            { type: 'bmptext', parent: 'gameContainer', text: 'ANSWER', font: 'Bebas_small', size: 36, tint: 0, name: 'answerText', x: vp.centerX, y: 985},

            { type: 'sprite', parent: 'gameContainer', id: 'cipher_entryField', name: 'entryField', x: 152, y: 1026, width: 460, height: 6},

            { type: 'sprite', parent: 'gameContainer', id: 'shiftLeft_btn', name: 'shiftLeft_btn', x: 230, y: 624, width: 76, height: 43},
            { type: 'sprite', parent: 'gameContainer', id: 'shiftRight_btn', name: 'shiftRight_btn', x: 460, y: 624, width: 76, height: 43},
            { type: 'shape', parent: 'gameContainer', name: 'shiftEditHitBox', x: vp.centerX - 65, y: 630, width: 130, height: 32, alpha: 0},
            { type: 'bmptext', parent: 'gameContainer', text: 'Shift [+0]', font: 'typrighter_small', size: 30, tint: 0, name: 'shiftReadout', x: vp.centerX, y: 633},

            { type: 'container', parent: 'gameContainer', name: 'wheelContainer', x: vp.centerX, y: 920},
            { type: 'shape', parent: 'gameContainer', name: 'wheelMask', x: 100, y: 680, width: 550, height: 240},
            { type: 'sprite', parent: 'wheelContainer', id: 'cipher_back', name: 'cipher_back', x: 0, y: 0, width: 472, height: 472, regX: 472, regY: 472},
            { type: 'sprite', parent: 'wheelContainer', id: 'cipher_top', name: 'cipher_top', x: 0, y: 0, width: 374, height: 382, regX: 186 * 2, regY: 195 * 2},

            { type: 'sprite', parent: 'gameContainer', id: 'drag_Prompt', name: 'dragPrompt', x: vp.centerX, y: 860, width: 154, height: 66, anchorX: 0.5, anchorY: 1, alpha: 0 },

            { type: 'sprite', parent: 'gameContainer', id: 'hint_btn_disabled', name: 'hint_btn', x: vp.centerX, y: 580, width: 162, height: 55, anchorX: 0.5, anchorY: 0.5},

            // { type: 'sprite', parent: 'gameContainer', id: 'checkAnswerOff_btn', name: 'checkAnswer_btn', x: 165, y: 1060, width: 434, height: 105},
            { type: 'sprite', parent: 'gameContainer', id: 'checkAnswerOff_btn', name: 'checkAnswer_btn', x: 165, y: 1060, width: 434, height: 105},
        ], this.container);

        this.resize();

        this.controller = new CaesarCipherController();
        this.children.scrambledText.text = this.controller.model.scrambledPhrase;
        this.children.scrambledText.anchor.x = 0.5;
        this.children.answerText.anchor.x = 0.5;

        this.children.shiftReadout.anchor.x = 0.5;
        this.currentShift = 0;

        this.children.instructions.anchor.x = 0.5;
        this.children.decodedTitle.anchor.x = 0.5;


        this.children.wheelContainer.mask = this.children.wheelMask;

        this.clicksAllowed = false;

        /*
        let event = koko.client.system.isMobile ? 'touchstart' : 'mousedown';

        this.children.shiftLeft_btn.interactive = true;
        this.children.shiftLeft_btn.on(event, this.shiftDown);

        this.children.shiftRight_btn.interactive = true;
        this.children.shiftRight_btn.on(event, this.shiftUp);
        */
        setupClicker(this.children.shiftLeft_btn, this.shiftDown);
        setupClicker(this.children.shiftRight_btn, this.shiftUp);

        this.children.wheelContainer.interactive = true;
        this.children.wheelContainer.on('mousedown', this.startDraggingWheel);
        this.children.wheelContainer.on('pointerdown', this.startDraggingWheel);
        this.children.wheelContainer.on('touchstart', this.startDraggingWheel);
        this.container.interactive = true;
        this.container.on('mousemove', this.dragWheel);
        this.container.on('pointermove', this.dragWheel);
        this.container.on('touchmove', this.dragWheel);
        this.container.on('mouseup', this.stopDraggingWheel);
        this.container.on('pointerup', this.stopDraggingWheel);
        this.container.on('touchend', this.stopDraggingWheel);
        document.onmouseleave = this.stopDraggingWheel;
        document.onpointerleave = this.stopDraggingWheel;
        document.onmouseup = this.stopDraggingWheel;
        document.onpointerup = this.stopDraggingWheel;

        /*
        this.children.checkAnswer_btn.interactive = true;
        this.children.checkAnswer_btn.on(event, this.submitAnswer);

        this.children.closeKeyboardOutside.interactive = true;
        this.children.closeKeyboardOutside.on(event, () => {if (this.keyboardOpen) {au.play('button', 1, false);} this.closeKeyboard()});

        this.children.shiftEditHitBox.interactive = true;
        this.children.shiftEditHitBox.on(event, () => {au.play('button', 1, false); this.openShiftKeyboard()});
        */
        setupClicker(this.children.checkAnswer_btn, this.submitAnswer);
        setupClicker(this.children.closeKeyboardOutside, () => {if (this.keyboardOpen) {au.play('button', 1, false);} this.closeKeyboard()});
        setupClicker(this.children.shiftEditHitBox, () => {au.play('button', 1, false); this.openShiftKeyboard()});

        this.clicksAllowed = true;

        if (this.answerInput == null) {
            this.answerInput = new Input(this.children.answerText, 400, 70, -200, -30);
	    	this.answerInput.setColors(0, 0);
		    this.answerInput.setDesktopClasses('answerInput', 'idle', 'active');
		    this.answerInput.setDisplayLength(23, "...");
            // this.answerInput.validation(function(){
                // var uname = this.val; // _t.removeKeywords(this.val);
                // _t.children.dataField_error.visible = uname.length < 2 || uname.length > 30;
            // });
            this.answerInput.mobileEditCallback = () => {au.play('button', 1, false); this.openKeyboard()};
            this.answerInput.desktopEditCallback = () => {au.play('button', 1, false); this.closeKeyboard()};
            this.answerInput.desktopEnterPressedCallback = () => {au.play('button', 1, false); this.submitAnswer()};
            if (koko.client.isTouch === true) {
                this.answerInput.desktopEditCallback = this.answerInput.mobileEditCallback;
            }
        }
        this.answerInput.resize();

        this.canSubmitAnswer = false;

        this.hintAllowed = false;
        /*
        this.children.hint_btn.interactive = false;
        this.children.hint_btn.on(event, () => {if (!this.popOpen) {au.play('button', 1, false);} this.showHint()});
        */
        setupClicker(this.children.hint_btn, () => {if (!this.popOpen) {au.play('button', 1, false);} this.showHint()});
        this.children.hint_btn.interactive = false;
    }

    resize () {
        // console.log('resize called');
        // v.get('ingamehud').resize();
        if (this.answerInput) {
            this.answerInput.resize();
        }
    }

    transitionIn (){
        this.buildView();
        this.show();
        this.enable();
        this.container.alpha = 0;
        gsap.to(this.container, {alpha:1, duration: 0.35});
        
        v.get('ingamehud').transitionIn(this);

        this.timeController = new GameTimeController();
        this.timeController.init(CAESAR.time);

        this.startGame();

        this.answerInput.enable();

        this.viewActive = true;
        this.hasDraggedWheel = false;
        setTimeout(this.promptDragWheel, 10000);

        this.showTutorial();
    }

    transitionOut (){
        document.onmouseleave = null;
        document.onpointerleave = null;
        document.onmouseup = null;
        document.onpointerup = null;

        this.closeKeyboard();
        gsap.to(this.container, {alpha:0, onComplete:this.transitionOutDone, duration: 0.35});
        v.get('ingamehud').transitionOut();
        this.stopGame();

        if (this.answerInput) {
            this.answerInput.disable();
            this.answerInput.remove();
            this.answerInput = null;
        }

        gsap.killTweensOf(this.children.dragPrompt);
        this.viewActive = false;
        this.popOpen = false;
    }

    transitionOutDone = () => {
        // gsap.killAll();
        // this.destroyGameObjects();  
        // game.destroy();
        // game = null;
        this.destroyView();
        this.hide();

        /*
        PIXI.Ticker.shared.stop();
        app.renderer.renderer.plugins.interaction.destroy();

        app.paused = true;
        app.renderer.destroy();
        PIXI.utils.destroyTextureCache();
        */
    }

    startGame () {
        this.enable();
   
        app.removeUpdateListener('ingame');

        /*
        game = new GameController();
        */
        // game.init();
           
        
		app.addUpdateListener('ingame', function(delta){ 
            this.update(delta);
        }.bind(this));
        

        app.addResizeListener('ingame', function(){
            this.resize();
        }.bind(this));
    }

    stopGame (){ 
        app.removeUpdateListener('ingame');
        while (app.updateListeners['ingame']) {
            app.removeUpdateListener('ingame');
        }

        app.removeResizeListener('ingame');
        while (app.resizeListeners['ingame']) {
            app.removeResizeListener('ingame');
        }
    }

    update($delta) {
        if (this.draggingWheel && this.updated) {
            this.lastAngleChange = 0;
        }
        this.updated = true;
        if (!this.popOpen) {
            this.timeController.update($delta);

            if (!this.hintAllowed && this.timeController.rank < 3) {
                this.hintAllowed = true;
                this.children.hint_btn.interactive = true;
                this.children.hint_btn.texture = PIXI.Texture.from('hint_btn_active.png');
            }

            if (!this.draggingWheel && this.lastAngleChange !== 0) {
                this.lastAngleChange *= 0.95;
                if (Math.abs(this.lastAngleChange) > 0.0001) {
                    let newWheelAngle = this.children.wheelContainer.rotation + this.lastAngleChange;
                    while (newWheelAngle < 0) {
                        newWheelAngle += Math.PI * 2;
                    }
                    while (newWheelAngle > Math.PI * 2) {
                        newWheelAngle -= Math.PI * 2;
                    }
                    this.children.wheelContainer.rotation = newWheelAngle;
                } else {
                    this.lastAngleChange = 0;
                }
            }

            if (this.answerInput.val.length > 0) {
                this.children.checkAnswer_btn.texture = PIXI.Texture.from('checkAnswer_btn.png');
                this.canSubmitAnswer = true;
            } else {
                this.children.checkAnswer_btn.texture = PIXI.Texture.from('checkAnswerOff_btn.png');
                this.canSubmitAnswer = false;
            }
        } else {
            this.clicksAllowed = false;
            this.draggingWheel = false;
            this.canSubmitAnswer = false;
            this.timeController.pauseUpdate($delta);
        }
    }

    shiftUp = (e) => {
        if (this.clicksAllowed) {
            au.play('shiftArrow', 1, false);
            if (this.keyboardOpen && this.currentKeyboard === SHIFT_KEYBOARD) {
                this.closeKeyboard();
            }
            this.lastAngleChange = 0;
            this.clicksAllowed = false;
            this.controller.testShiftUp();
            this.showShift();
        }
    }

    shiftDown = (e) => {
        if (this.clicksAllowed) {
            au.play('shiftArrow', 1, false);
            if (this.keyboardOpen && this.currentKeyboard === SHIFT_KEYBOARD) {
                this.closeKeyboard();
            }
            this.lastAngleChange = 0;
            this.clicksAllowed = false;
            this.controller.testShiftDown();
            this.showShift();
        }
    }

    showShift = () => {
        this.children.shiftReadout.text = 'Shift [+' + this.controller.model.currentTestShift + ']';
        gsap.killTweensOf(this.children.cipher_top);
        // gsap.killTweensOf(this.children.wheelContainer);
        let r = this.controller.model.currentTestShift * SHIFT_ROTATE_INCREMENTS;
        gsap.to(this.children.cipher_top, {rotation: r, duration: 0.3, ease: Power2.easeInOut, onComplete: () => {this.clicksAllowed = true}});
        // gsap.to(this.children.wheelContainer, {rotation: -r, duration: 0.4, delay: 0.1, ease: Power2.easeInOut, onComplete: () => {this.clicksAllowed = true}});
    }

    draggingWheel = false;
    startMouseAngle = 0;
    startMousePoint = null;
    startWheelRotation = null;
    newWheelRotation = null;
    updated = false;
    lastMousePoint = null;
    lastAngleChange = 0;
    hasDraggedWheel = false;
    startDraggingWheel = (e) => {
        if (this.clicksAllowed) {
            if (this.keyboardOpen && this.currentKeyboard === SHIFT_KEYBOARD) {
                this.closeKeyboard();
            }
            this.draggingWheel = true;
            // console.log('start drag: ', e);
            this.startMousePoint = this.container.toLocal(e.data.global);
            this.startMousePoint.x -= this.children.wheelContainer.x;
            this.startMousePoint.y -= this.children.wheelContainer.y;
            this.startMouseAngle = Math.atan2(this.startMousePoint.y, this.startMousePoint.x);
            this.startWheelRotation = this.children.wheelContainer.rotation;
            this.lastAngleChange = 0;
            // console.log(this.startMousePoint, this.startMouseAngle, this.startWheelRotation);
        }
    }

    dragWheel = (e) => {
        if (this.draggingWheel && this.updated) {
            // console.log('drag wheel: ', e);
            let thisPoint = this.container.toLocal(e.data.global);
            thisPoint.x -= this.children.wheelContainer.x;
            thisPoint.y -= this.children.wheelContainer.y;

            let thisAngle = Math.atan2(thisPoint.y, thisPoint.x);
            let angleDiff = thisAngle - this.startMouseAngle;
            // console.log(angleDiff, this.startWheelRotation + angleDiff);
            let newWheelAngle = this.startWheelRotation + angleDiff;
            while (newWheelAngle < 0) {
                newWheelAngle += Math.PI * 2;
            }
            while (newWheelAngle > Math.PI * 2) {
                newWheelAngle -= Math.PI * 2;
            }
            // console.log('New wheel angle before set: ', newWheelAngle);
            this.lastAngleChange = newWheelAngle - this.children.wheelContainer.rotation;
            while (this.lastAngleChange > Math.PI * 2) {
                this.lastAngleChange -= Math.PI * 2;
            }
            while (this.lastAngleChange < -Math.PI * 2) {
                this.lastAngleChange += Math.PI * 2;
            }
            this.children.wheelContainer.rotation = newWheelAngle;
            this.updated = false;
            this.hasDraggedWheel = true;
        }
    }

    stopDraggingWheel = (e) => {
        this.draggingWheel = false;
        this.newWheelRotation = null;
        this.lastMousePoint = null;
        // console.log('stop drag: ', e);
    }

    submitAnswer = (e) => {
        if (this.keyboardOpen && this.currentKeyboard === SHIFT_KEYBOARD) {
            this.closeKeyboard();
        }
        if (this.canSubmitAnswer && !this.popOpen && !this.keyboardOpen) {
            if (this.controller.checkAnswer(this.answerInput.val)) {
                au.play('correct', 1, false);
                this.stopGame();
                gameState.setGameScore(this.timeController.rank);
                // this.transitionOut();
                this.popOpen = true;
                this.answerInput.disable();
                v.get('ingamehud').enabled = false;
                v.get('gameover').transitionIn();
            } else {
                au.play('wrong', 1, false);
                this.popOpen = true;
                this.answerInput.disable();
                v.get('ingamehud').enabled = false;
                v.get('wronganswer').transitionIn(this);
            }
        }
    }

    popClosed = () => {
        if (this.popOpen) {
            this.popOpen = false;
            this.clicksAllowed = true;
            this.answerInput.enable();
            v.get('ingamehud').enabled = true;
        }
    }

    showQuitPop = () => {
        if (!this.popOpen) {
            this.popOpen = true;
            this.answerInput.disable();
            this.closeKeyboard();
            v.get('ingamehud').enabled = false;
            v.get('quitpopup').transitionIn(this);
        }
    }

    showTutorial = () => {
        if (!this.popOpen) {
            this.popOpen = true;
            this.answerInput.disable();
            v.get('ingamehud').enabled = false;
            v.get('cstutorial').transitionIn(this);
        }
    }

    showHint = () => {
        if (!this.popOpen) {
            this.popOpen = true;
            this.answerInput.disable();
            v.get('ingamehud').enabled = false;
            v.get('cshint').transitionIn(this);
        }
    }

    openShiftKeyboard = () => {
        if (this.keyboardOpen && this.currentKeyboard !== SHIFT_KEYBOARD && !this.popOpen) {
            this.customKeyboard.removeKeyboard();
            this.keyboardOpen = false;
            this.currentKeyboard = NO_KEYBOARD;
        }
        if (!this.keyboardOpen && !this.popOpen) {
            let vp = app.viewPort;
            this.customKeyboard = new SimpleCustomKeyboard(keyboardSetup);
            this.keyboardView = this.customKeyboard.createKeyboard(vp.centerX, 675, this.container, this.handleShiftCustomKeyboardClick, 1);
            this.keyboardView.alpha = 0;
            this.keyboardOpen = true;
            // this.customKeyboard.children.bg.visible = false;
            gsap.to(this.keyboardView, {alpha:1, duration: 0.35});

            this.currentKeyboard = SHIFT_KEYBOARD;
        } else
        if (this.keyboardOpen && !this.popOpen) {
            this.closeKeyboard();
        }
    }

    openKeyboard = () => {
        if (this.keyboardOpen && this.currentKeyboard !== ANSWER_KEYBOARD && !this.popOpen) {
            this.customKeyboard.removeKeyboard();
            this.keyboardOpen = false;
            this.currentKeyboard = NO_KEYBOARD;
        }
        if (!this.keyboardOpen && !this.popOpen) {
            let vp = app.viewPort;
            this.customKeyboard = new SimpleCustomKeyboard(keyboardSetup);
            this.keyboardView = this.customKeyboard.createKeyboard(vp.centerX, 1044, this.container, this.handleCustomKeyboardClick, 0);
            this.keyboardView.alpha = 0;
            this.keyboardOpen = true;
            gsap.to(this.keyboardView, {alpha:1, duration: 0.35});

            let currentVal = this.answerInput.val;
            this.children.answerText.text = currentVal + '|';
            this.currentKeyboard = ANSWER_KEYBOARD;
        } else
        if (this.keyboardOpen && !this.popOpen) {
            this.closeKeyboard();
        }
    }

    closeKeyboard = () => {
        if (this.keyboardOpen) {
            this.keyboardOpen = false;
            gsap.to(this.keyboardView, {alpha:0, duration: 0.35, onComplete: this.customKeyboard.removeKeyboard});

            if (this.currentKeyboard === ANSWER_KEYBOARD) {
                let currentVal = this.answerInput.val;
                if (currentVal !== '') {
                    this.children.answerText.text = currentVal;
                } else {
                    this.children.answerText.text = 'ANSWER';
                }
            }

            this.currentKeyboard = NO_KEYBOARD;
        }
    }

    handleCustomKeyboardClick = (kId, e) => {
        if (this.keyboardOpen && !this.popOpen) {
            // console.log('custom keyboard: ', kId, e);
            if (kId.toUpperCase() === 'CLOSE') {
                this.closeKeyboard();
            } else {
                let currentVal = this.answerInput.val;
                if (kId.toUpperCase() === 'SPC' || kId.toUpperCase() === 'SPACE') {
                    currentVal += ' ';
                } else
                if (kId.toUpperCase() === 'DEL') {
                    if (currentVal.length > 0) {
                        currentVal = currentVal.substr(0, currentVal.length - 1);
                    }
                } else {
                    currentVal += kId;
                }
                this.answerInput.val = currentVal;
                this.children.answerText.text = currentVal + '|';
            }
        }
    }

    handleShiftCustomKeyboardClick = (kId, e) => {
        if (this.keyboardOpen && !this.popOpen) {
            let newShift = parseInt(kId);
            if (isNaN(newShift)) {
                au.play('shiftArrow', 1, false);
                this.controller.setShift(newShift);
                this.showShift();
                this.closeKeyboard();
            }
        }
    }

    promptDragWheel = () => {
        if (this.viewActive) {
            if (!this.hasDraggedWheel) {
                gsap.to(this.children.dragPrompt, {alpha: 1, duration: 0.35});
                // gsap.to(this.children.dragPrompt, {alpha: 0.6, duration: 0.4, yoyo: true, repeat: 5, delay: 0.7});
                gsap.to(this.children.dragPrompt, {rotation: 0.1, duration: 0.2, delay: 0.7, ease: Power2.easeOut});
                gsap.to(this.children.dragPrompt, {rotation: -0.1, duration: 0.4, yoyo: true, repeat: 5, delay: 0.9, ease: Power2.easeInOut,
                    onComplete: () => {if (this.viewActive) { gsap.to(this.children.dragPrompt, {rotation: 0, duration: 0.2, ease: Power2.easeOut}) }}
                });
                gsap.to(this.children.dragPrompt, {alpha: 0, duration: 0.5, delay: 5});
            } else {
                this.hasDraggedWheel = false;
            }
            setTimeout(this.promptDragWheel, 20000);
        }
    }
}